import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import GlobalActivities from './GlobalActivities';
import ProjectActivities from './ProjectActivities';
import CategoryActivities from './CategoryActivities';
import { getUserRoles } from 'src/redux/features/users/usersSlice';
import { Card, Tabs, TabsProps, Typography } from 'antd';
import { IProjectResponse } from 'src/models/Project';
import en from 'src/messages/en.json';

const ActivitiesList = ({ isModalOpen }) => {
  const { Title } = Typography;
  const userRoles = useSelector(getUserRoles);
  const [key, setKey] = useState('global');
  const [selectedProject, setSelectedProject] = useState<IProjectResponse>();

  useEffect(() => {
    if (
      userRoles.data.includes('CapexCategoryManager') &&
      !userRoles.data.includes('CapexAdmin') &&
      !userRoles.data.includes('CapexProjectLeader')
    ) {
      setKey('category');
    }
  }, [userRoles.data]);

  const handleTabChange = () => {
    setSelectedProject(undefined);
  };

  const items = [
    {
      key: '1',
      label: en.Activities.Label.globalActivities,
      component: (k) => <GlobalActivities active={k} />,
      rolesAllowed: ['CapexAdmin', 'CapexProjectLeader'],
    },
    {
      key: '2',
      label: en.Activities.Label.customActivities,
      component: () => (
        <ProjectActivities
          isModalOpen={isModalOpen}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        />
      ),
      rolesAllowed: ['CapexAdmin', 'CapexProjectLeader'],
    },
    {
      key: '3',
      label: en.Activities.Label.categoryActivities,
      component: () => <CategoryActivities />,
      rolesAllowed: ['CapexCategoryManager'],
    },
  ];

  const accessibleTabs = items
    .filter(({ rolesAllowed }) =>
      rolesAllowed.some((role) => userRoles?.data?.includes(role)),
    )
    .map(({ key: tabKey, label, component }) => ({
      key: tabKey,
      label,
      children: component(key),
    }));

  return (
    <>
      <Title level={4} style={{ textAlign: 'left' }}>
        {en.Activities.Title.editActivities}
      </Title>
      <Card size="small">
        <Tabs
          defaultActiveKey="1"
          items={accessibleTabs}
          onChange={handleTabChange}
        />
      </Card>
    </>
  );
};

export default ActivitiesList;
